// Shared Business Health Score from the public signals pulled during a lookup/scan.
// Used by the Prospector lookup, the Market-scan list, and the Leads table badge.
const BBB_BASE = { "A+": 96, A: 92, "A-": 88, "B+": 82, B: 78, "B-": 73, "C+": 67, C: 62, "C-": 57, "D+": 50, D: 45, "D-": 40, F: 32 };

export function scoreMeta(score) {
  const grade = score >= 90 ? "A" : score >= 80 ? "B" : score >= 70 ? "C" : score >= 55 ? "D" : "F";
  const label = score >= 80 ? "Healthy" : score >= 65 ? "Stable" : score >= 50 ? "At risk" : "Distressed";
  const color = score >= 80 ? "#4b7a3a" : score >= 65 ? "#8a6d2f" : score >= 50 ? "#c08a2e" : "#b23a48";
  return { grade, label, color };
}

export function computeHealth(sel, reported) {
  if (!sel) return null;
  const rating = (sel.bbb_rating || "").toUpperCase().trim();
  let score = BBB_BASE[rating] ?? 68; // NR / unknown → neutral
  const comp = typeof sel.complaints === "number" ? sel.complaints : 0;
  score -= Math.min(28, comp * 2);
  if (sel.accredited) score += 5;
  const negThemes = (reported?.reviews || []).length;
  score -= Math.min(10, negThemes * 1.5);
  score = Math.max(5, Math.min(99, Math.round(score)));
  const { grade, label, color } = scoreMeta(score);
  const factors = [
    rating ? `BBB rating ${rating}` : "No BBB rating on file",
    `${comp} complaint${comp === 1 ? "" : "s"} on file`,
    sel.accredited ? "BBB accredited (+5)" : "Not BBB accredited",
    negThemes ? `${negThemes} reported complaint theme${negThemes === 1 ? "" : "s"}` : null,
  ].filter(Boolean);
  return { score, grade, label, color, factors };
}
